import * as React from 'react'
import { DayPicker } from 'react-day-picker'

import { ChevronLeftIcon } from '@radix-ui/react-icons'
import { clsx } from 'clsx'

export type CalendarProps = React.ComponentProps<typeof DayPicker>

export function Calendar({ className, classNames, ...props }: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays
      className={clsx('py-3 text-dark-bright', className)}
      classNames={{
        months: 'flex',
        month_caption: 'font-medium text-sm pb-3 leading-normal text-center',
        nav: 'absolute top-0 left-0 right-0',
        button_previous:
          'absolute hover:bg-dark-shade-hover cursor-default transition-colors p-1 rounded left-[1.125rem] top-3',
        button_next:
          'absolute hover:bg-dark-shade-hover cursor-default transition-colors p-1 rounded right-[1.125rem] top-3 rotate-180 aria-disabled:opacity-30 aria-disabled:cursor-default',
        table: 'border-collapse',
        weekdays:
          'text-dark-faint font-semibold text-[0.75rem] pointer-events-none',
        weekday: 'w-8 h-5',
        outside: 'text-dark-faint',
        day: 'size-8 relative rounded transition-[background-color,_border-radius,_color]',
        today: 'text-dark-control-base',
        day_button:
          'cursor-default absolute inset-0 text-xs font-medium rounded hover:bg-dark-shade-hover transition-[background-color]',
        range_start:
          '!bg-dark-control-base !rounded-l [&>button:hover]:!bg-transparent !text-white',
        range_end:
          '!bg-dark-control-base !rounded-r [&>button:hover]:!bg-transparent !text-white',
        selected: 'bg-dark-elevated rounded-none',
        disabled: 'pointer-events-none opacity-10',
        ...classNames,
      }}
      components={{
        Chevron: ({ className, ...props }) => (
          <ChevronLeftIcon className={clsx('h-4 w-4', className)} {...props} />
        ),
      }}
      {...props}
    />
  )
}
